/* ============================================================================
 * MAMM Warenkorb (16.10.2026) — kleine Helfer für Schublade und Warenkorb-Seite.
 * 1. Rabattcode-Pille: × entfernt genau diesen Code (übrige Codes bleiben),
 *    danach rendert Pebble die Warenkorb-Sektionen neu (cart:update).
 * 2. Karte «Für dich» (S4/S10b): zwei AntiDirt-Empfehlungen «Passt dazu»
 *    hinter dem Geschenk (Shopify-Empfehlungen, nur AntiDirt, nicht schon im
 *    Warenkorb, höchstens 4 Varianten), Pfeile, Punkte, Hinzufügen.
 * ============================================================================ */
(function () {
  'use strict';

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function dispatchCartUpdate(sections, itemCount) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: null,
        sourceId: '',
        data: { sections: sections || {}, itemCount: itemCount, isIncremental: false, source: 'mamm-warenkorb' },
      },
    }));
  }

  async function codeEntfernen(button) {
    var code = button.getAttribute('data-mw-code-weg');
    var box = button.closest('[data-mw-codes]');
    if (!code || !box) return;
    var rest = (box.getAttribute('data-mw-codes') || '').split(',').filter(function (c) {
      return c && c !== code;
    });
    button.disabled = true;
    try {
      var ids = sectionIds();
      var res = await fetch((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_update_url) || '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: rest.join(','), sections: ids }),
      });
      var data = await res.json();
      dispatchCartUpdate(data.sections, data.item_count);
    } catch (e) {
      button.disabled = false;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-mw-code-weg]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    codeEntfernen(button);
  });

  /* ---------- 1a. Gutscheincode einlösen (nur Warenkorb-Seite, Analyse C1, Albinot 17.10.2026) ----------
   * Link öffnet Feld und Knopf. Der Code kommt zu den bestehenden Codes; gilt er nicht
   * (Shopify meldet applicable: false), nehmen wir ihn wieder weg und zeigen einen kurzen Satz. */
  async function codeEinloesen(gc) {
    var input = gc.querySelector('[data-mw-gc-in]');
    var ok = gc.querySelector('[data-mw-gc-ok]');
    var fehler = gc.querySelector('[data-mw-gc-fehler]');
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    var box = gc.closest('[data-mw-codes]');
    var alt = ((box && box.getAttribute('data-mw-codes')) || '').split(',').filter(Boolean);
    var url = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_update_url) || '/cart/update.js';
    var senden = function (codes, mitSections) {
      var body = { discount: codes.join(',') };
      if (mitSections) body.sections = sectionIds();
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (r) { return r.json(); });
    };
    ok.disabled = true;
    fehler.hidden = true;
    try {
      var data = await senden(alt.concat([code]), true);
      var treffer = (data.discount_codes || []).filter(function (d) {
        return d.code && d.code.toLowerCase() === code.toLowerCase();
      })[0];
      if (!treffer || !treffer.applicable) {
        await senden(alt, false);
        fehler.hidden = false;
        ok.disabled = false;
        input.focus();
        return;
      }
      dispatchCartUpdate(data.sections, data.item_count);
    } catch (e) {
      fehler.hidden = false;
      ok.disabled = false;
    }
  }

  document.addEventListener('click', function (event) {
    var auf = event.target.closest && event.target.closest('[data-mw-gc-auf]');
    if (auf) {
      var gc = auf.closest('[data-mw-gc]');
      var feld = gc && gc.querySelector('.mw-gc__feld');
      if (!feld) return;
      feld.hidden = false;
      auf.setAttribute('aria-expanded', 'true');
      auf.hidden = true;
      var input = feld.querySelector('[data-mw-gc-in]');
      if (input) input.focus();
      return;
    }
    var ok = event.target.closest && event.target.closest('[data-mw-gc-ok]');
    if (ok) {
      event.preventDefault();
      codeEinloesen(ok.closest('[data-mw-gc]'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-mw-gc-in]');
    if (!input) return;
    event.preventDefault();
    codeEinloesen(input.closest('[data-mw-gc]'));
  });

  /* ---------- 1c. Zuklappen: «Passt dazu» (fd) und Geschenk-Karte (gs) (Wunsch Albinot 17.10.2026) ----------
   * Klasse mw-<art>-zu auf <html>, damit der Zustand auch nach dem Neuzeichnen der Schublade gilt.
   * Gespeichert je Besucher (localStorage mw_<art>_zu), ohne Speicher ist alles offen. */
  var ZUKLAPP = ['fd', 'gs'];
  function zuLesen(art) { try { return localStorage.getItem('mw_' + art + '_zu') === '1'; } catch (e) { return false; } }
  function zuSetzen(art, zu) {
    document.documentElement.classList.toggle('mw-' + art + '-zu', zu);
    try { localStorage.setItem('mw_' + art + '_zu', zu ? '1' : '0'); } catch (e) {}
    zuKnoepfe();
  }
  function zuKnoepfe() {
    document.querySelectorAll('[data-mw-zuklapp]').forEach(function (b) {
      var zu = document.documentElement.classList.contains('mw-' + b.getAttribute('data-mw-zuklapp') + '-zu');
      b.setAttribute('aria-expanded', zu ? 'false' : 'true');
      var t = b.querySelector('[data-mw-zuklapp-text]');
      if (t) t.textContent = zu ? t.getAttribute('data-l-auf') : t.getAttribute('data-l-zu');
    });
  }
  ZUKLAPP.forEach(function (art) { if (zuLesen(art)) document.documentElement.classList.add('mw-' + art + '-zu'); });
  document.addEventListener('click', function (event) {
    var b = event.target.closest && event.target.closest('[data-mw-zuklapp]');
    if (!b) return;
    event.preventDefault();
    var art = b.getAttribute('data-mw-zuklapp');
    zuSetzen(art, !document.documentElement.classList.contains('mw-' + art + '-zu'));
  });
  document.addEventListener('cart:update', function () { setTimeout(zuKnoepfe, 60); setTimeout(zuKnoepfe, 600); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zuKnoepfe); else zuKnoepfe();

  /* ---------- 1b. Zusammengefasste Zeilen (gleicher Artikel, von Shopify geteilt) ----------
   * Die Zeile zeigt die Gesamtmenge. Plus, Minus, Eingabe und Entfernen setzen die erste Zeile
   * der Gruppe auf die neue Gesamtmenge und die übrigen auf 0. Shopify teilt danach selbst neu. */
  async function gruppeSetzen(row, menge) {
    var keys = (row.getAttribute('data-mw-gruppe') || '').split(',').filter(Boolean);
    if (!keys.length) return;
    var updates = {};
    keys.forEach(function (k, i) { updates[k] = i === 0 ? Math.max(0, menge) : 0; });
    row.classList.add('mw-laedt');
    try {
      var res = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sectionIds() }),
      });
      var data = await res.json();
      dispatchCartUpdate(data.sections, data.item_count);
    } catch (e) {
      row.classList.remove('mw-laedt');
    }
  }

  function gruppenKlick(event) {
    var t = event.target;
    if (!t.closest) return;
    var row = t.closest('[data-mw-gruppe]');
    if (!row) return;
    var menge = Number(row.getAttribute('data-mw-menge')) || 0;
    var neu = null;
    if (t.closest('.quantity-plus')) neu = menge + 1;
    else if (t.closest('.quantity-minus')) neu = menge - 1;
    else if (t.closest('.cart-items__remove-button')) neu = 0;
    if (neu === null) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    gruppeSetzen(row, neu);
  }
  window.addEventListener('click', gruppenKlick, true);

  function gruppenEingabe(event) {
    var input = event.target;
    if (!input.matches || !input.matches('.quantity-input')) return;
    var row = input.closest('[data-mw-gruppe]');
    if (!row) return;
    event.stopImmediatePropagation();
    var neu = parseInt(input.value, 10);
    if (isNaN(neu) || neu === Number(row.getAttribute('data-mw-menge'))) return;
    gruppeSetzen(row, neu);
  }
  window.addEventListener('blur', gruppenEingabe, true);
  window.addEventListener('change', gruppenEingabe, true);

  /* ---------- 2. Karte «Für dich» ---------- */
  // Schublade 2 Empfehlungen, Warenkorb-Seite 3 nebeneinander (Vorschlag 17.10.2026)
  var ANZAHL = document.querySelector('.cart-page') ? 3 : 2;
  var cache = { key: null, produkte: [] };
  var laeuft = null;
  var nochmal = false;

  function geld(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF';
    var zeichen = { CHF: 'CHF', EUR: '€' }[cur] || cur;
    var wert = (Number(cents) || 0) / 100;
    var txt;
    try {
      txt = wert.toLocaleString(cur === 'CHF' ? 'de-CH' : 'de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      txt = wert.toFixed(2);
    }
    return cur === 'EUR' ? zeichen + txt : zeichen + ' ' + txt;
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function bildUrl(src, breite) {
    if (!src) return '';
    var url = String(src);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite;
  }

  function kurztitel(p) {
    var t = String(p.title || '');
    var v = String(p.vendor || '');
    if (v && t.indexOf(v + ' ') === 0) t = t.slice(v.length + 1);
    t = t.replace(/^AntiDirt\s+/i, '').replace(/\bPremium\s+/g, '').trim();
    var typ = String(p.type || '').trim();
    if (typ && t.indexOf(' ' + typ) > 0) t = t.slice(0, t.indexOf(' ' + typ));
    // AntiDirt-Namen sind ein Wort wie «WashWelly»: dahinter nur Grössen-Wörter behalten
    var woerter = t.split(' ');
    if (/[a-z][A-Z]/.test(woerter[0])) {
      var gross = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'Mini', 'Maxi', 'Set', 'Kit'];
      t = woerter[0] + woerter.slice(1).filter(function (w) { return gross.indexOf(w) !== -1; }).map(function (w) { return ' ' + w; }).join('');
    }
    return t;
  }

  function istAntiDirt(p) {
    return String(p.vendor || '').toLowerCase() === 'antidirt' || /^AntiDirt\s/i.test(String(p.title || ''));
  }

  async function warenkorb() {
    var r = await fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function empfehlungen(produktId, intent) {
    var r = await fetch(root() + 'recommendations/products.json?product_id=' + produktId + '&limit=10&intent=' + intent, {
      credentials: 'same-origin',
    });
    if (!r.ok) return [];
    var d = await r.json();
    return (d && d.products) || [];
  }

  async function sammeln(cart) {
    var imKorb = {};
    var quellen = [];
    (cart.items || []).forEach(function (it) {
      imKorb[it.product_id] = true;
      var geschenk = it.properties && it.properties._mamm_gift === 'true';
      if (!geschenk && quellen.indexOf(it.product_id) === -1) quellen.push(it.product_id);
    });
    var key = Object.keys(imKorb).sort().join(',');
    if (cache.key === key) return cache.produkte;
    var gewaehlt = [];
    var gesehen = {};
    function nimm(liste) {
      liste.forEach(function (p) {
        if (gewaehlt.length >= ANZAHL || gesehen[p.id] || imKorb[p.id]) return;
        gesehen[p.id] = true;
        if (!p.available || !istAntiDirt(p)) return;
        // wie im alten Blatt «Kombiniere Smart»: keine Vorbestellungen, keine Gratisprodukte
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        if (tags.indexOf('vorbestellung') !== -1 || tags.indexOf('gratisprodukt') !== -1) return;
        if ((p.variants || []).length > 4) return;
        gewaehlt.push(p);
      });
    }
    // 1. Von Hand gepflegt (Metafeld «Häufig zusammen gekauft» der Artikel im Warenkorb)
    var fbt = ((document.querySelector('[data-mw-fbt]') || {}).getAttribute ? document.querySelector('[data-mw-fbt]').getAttribute('data-mw-fbt') : '') || '';
    var fbtHandles = fbt.split(',').filter(Boolean);
    for (var f = 0; f < fbtHandles.length && gewaehlt.length < ANZAHL; f++) {
      try {
        var fp = await fetch(root() + 'products/' + fbtHandles[f] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
        if (fp) {
          fp.url = fp.url || '/products/' + fp.handle;
          nimm([fp]);
        }
      } catch (e) {}
    }
    // 2. Shopify-Empfehlungen, 3. Bestseller (unten)
    var erste = quellen.slice(0, 3);
    for (var i = 0; i < erste.length && gewaehlt.length < ANZAHL; i++) {
      nimm(await empfehlungen(erste[i], 'complementary'));
    }
    gesehen = {};
    gewaehlt.forEach(function (p) { gesehen[p.id] = true; });
    for (var j = 0; j < erste.length && gewaehlt.length < ANZAHL; j++) {
      nimm(await empfehlungen(erste[j], 'related'));
    }
    // Rückfall (17.10.2026): Findet Shopify zu wenig, kommen AntiDirt-Bestseller dazu,
    // damit «Passt dazu» ab dem ersten Artikel erscheint (auch bei Geräten und Fremdmarken).
    if (gewaehlt.length < ANZAHL) {
      try {
        var liste = await fetch(root() + 'collections/bestseller-bei-mamm/products.json?limit=30', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        var handles = ((liste && liste.products) || []).filter(function (p) {
          return istAntiDirt(p) && !imKorb[p.id] && !gesehen[p.id];
        }).map(function (p) { return p.handle; });
        for (var k = 0; k < handles.length && gewaehlt.length < ANZAHL; k++) {
          var prod = await fetch(root() + 'products/' + handles[k] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
          if (prod) {
            prod.url = prod.url || '/products/' + prod.handle;
            nimm([prod]);
          }
        }
      } catch (e) {}
    }
    // Sterne (Wunsch Albinot 17.10.2026): Note und Anzahl aus Judge.me (Shopify-Felder
    // reviews.*) über die kleine Vorlage product.mwsterne; nur für die gewählten Produkte.
    await Promise.all(gewaehlt.map(async function (p) {
      if (p.mwSterne !== undefined || !p.handle) return;
      p.mwSterne = null;
      try {
        var r = await fetch(root() + 'products/' + p.handle + '?view=mwsterne', { credentials: 'same-origin' });
        if (r.ok) p.mwSterne = await r.json();
      } catch (e) {}
    }));
    cache = { key: key, produkte: gewaehlt };
    return gewaehlt;
  }

  // Sterne-Zeile erst ab 5 Bewertungen, sonst nichts (Tafel «Artikelkarten kompakter», Vorschlag B)
  function sterneHtml(p) {
    var s = p.mwSterne;
    if (!s || !(s.n >= 5) || !(s.r > 0)) return '';
    var note = (Math.round(s.r * 10) / 10).toFixed(1);
    return '<span class="mw-fd__sterne" aria-label="' + esc(note + ' / 5 (' + s.n + ')') + '">' +
      '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path fill="#E8A33D" d="M12 2l3 6.6 7.2.7-5.4 4.9 1.6 7.1L12 17.6 5.6 21.3l1.6-7.1L1.8 9.3 9 8.6z"/></svg>' +
      '<b>' + esc(note) + '</b><span>(' + esc(String(s.n)) + ')</span></span>';
  }

  function karteHtml(p, l) {
    var varianten = (p.variants || []).filter(function (v) { return v.available; });
    var erste = varianten[0] || (p.variants || [])[0];
    if (!erste) return '';
    var chips = '';
    if ((p.variants || []).length > 1) {
      chips = '<span class="mw-fd__chips">' + varianten.map(function (v) {
        var vb = v.featured_image && (v.featured_image.src || v.featured_image);
        return '<button type="button" class="mw-fd__chip" data-mw-fd-variante="' + v.id + '" data-preis="' + v.price + '"' +
          (vb && typeof vb === 'string' ? ' data-bild="' + esc(bildUrl(vb, 400)) + '"' : '') +
          ' aria-pressed="' + (v.id === erste.id) + '">' + esc(String(v.title).replace(/ \/ /g, ' · ')) + '</button>';
      }).join('') + '</span>';
    }
    var preis = esc(geld(erste.price));
    if (erste.compare_at_price && erste.compare_at_price > erste.price) {
      preis = '<s>' + esc(geld(erste.compare_at_price)) + '</s> ' + preis;
    }
    return '<div class="mw-fd__karte" role="listitem" data-mw-fd-produkt="' + p.id + '">' +
      '<a class="mw-fd__bild" href="' + esc(p.url || ('/products/' + p.handle)) + '" tabindex="-1">' +
      ((function () {
        var vb = erste.featured_image && (erste.featured_image.src || erste.featured_image);
        var src = (typeof vb === 'string' && vb) || p.featured_image;
        return src ? '<img src="' + esc(bildUrl(src, 400)) + '" alt="" width="64" height="64" loading="lazy">' : '';
      })()) +
      '</a>' +
      '<div class="mw-fd__text">' +
      '<span class="mw-fd__art">' + esc(l.lPasst || 'Passt dazu') + '</span>' +
      '<span class="mw-marke">AntiDirt</span>' +
      '<b class="mw-fd__titel">' + esc(kurztitel(p)) + '</b>' +
      (l.lSterne === 'false' ? '' : sterneHtml(p)) +
      (p.type ? '<span class="mw-fd__info">' + esc(p.type) + '</span>' : '') +
      chips +
      '</div>' +
      // Aufbau wie die Artikelzeile (Wunsch 17.10.2026): rechts oben der Preis, darunter «Hinzufügen»
      '<div class="mw-fd__rechts">' +
      '<span class="mw-fd__preis" data-mw-fd-preis>' + preis + '</span>' +
      '<button type="button" class="mw-fd__knopf" data-mw-fd-hinzu="' + erste.id + '">' + esc(l.lHinzu || 'Hinzufügen') + '</button>' +
      '</div>' +
      '</div>';
  }

  // Spur immer genau auf eine Karte stellen (nach Wischen und nach jedem Neuaufbau der Karten)
  function einrasten(spur, sanft) {
    if (!spur || !spur.clientWidth) return;
    var i = Math.round(spur.scrollLeft / spur.clientWidth);
    var ziel = i * spur.clientWidth;
    if (Math.abs(spur.scrollLeft - ziel) > 2) spur.scrollTo({ left: ziel, behavior: sanft ? 'smooth' : 'auto' });
  }
  document.addEventListener('scrollend', function (event) {
    var spur = event.target;
    if (spur && spur.matches && spur.matches('[data-mw-fd-spur], [data-mw-zitat-spur]')) einrasten(spur, true);
  }, true);

  function punkteAktualisieren(box) {
    if (!box) return;
    var spur = box.querySelector('[data-mw-fd-spur]');
    var punkte = box.querySelector('[data-mw-fd-punkte]');
    if (!spur || !punkte) return;
    var n = spur.querySelectorAll('.mw-fd__karte').length;
    var aktiv = spur.clientWidth ? Math.round(spur.scrollLeft / spur.clientWidth) : 0;
    var html = '';
    if (n > 1) {
      for (var i = 0; i < n; i++) html += '<i' + (i === aktiv ? ' class="ist"' : '') + '></i>';
    }
    if (punkte.innerHTML !== html) punkte.innerHTML = html;
    box.toggleAttribute('data-mehrere', n > 1);
    box.querySelectorAll('[data-mw-fd-pfeil]').forEach(function (b) {
      var r = Number(b.getAttribute('data-mw-fd-pfeil'));
      b.disabled = n < 2 || (r < 0 && aktiv <= 0) || (r > 0 && aktiv >= n - 1);
    });
  }

  async function fuellen() {
    if (!document.querySelector('[data-mw-fd]')) return;
    if (laeuft) {
      nochmal = true;
      return laeuft;
    }
    laeuft = (async function () {
      try {
        var cart = await warenkorb();
        var produkte = cart.items && cart.items.length ? await sammeln(cart) : [];
        document.querySelectorAll('[data-mw-fd]').forEach(function (box) {
          var ziel = box.querySelector('[data-mw-fd-empf]');
          if (!ziel) return;
          var html = produkte.map(function (p) { return karteHtml(p, box.dataset); }).join('');
          if (ziel.innerHTML !== html) ziel.innerHTML = html;
          ziel.setAttribute('data-gefuellt', '');
          box.toggleAttribute('data-empf', !!html);
          einrasten(box.querySelector('[data-mw-fd-spur]'), false);
          punkteAktualisieren(box);
        });
      } catch (e) {
        /* Empfehlungen sind ein Zusatz: bei einem Fehler bleibt nur das Geschenk */
      } finally {
        laeuft = null;
        if (nochmal) {
          nochmal = false;
          spaeter();
        }
      }
    })();
    return laeuft;
  }

  async function hinzufuegen(button) {
    var id = button.getAttribute('data-mw-fd-hinzu');
    if (!id || button.disabled) return;
    button.disabled = true;
    button.classList.add('mw-fd__knopf--laedt');
    try {
      var res = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { _mamm_quelle: 'warenkorb_empfehlung' } }], sections: sectionIds() }),
      });
      var data = await res.json();
      if (!res.ok) throw new Error(data && data.description);
      var cart = await warenkorb();
      dispatchCartUpdate(data.sections, cart.item_count);
    } catch (e) {
      button.disabled = false;
      button.classList.remove('mw-fd__knopf--laedt');
    }
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;
    var pfeil = t.closest('[data-mw-fd-pfeil]');
    if (pfeil) {
      var spur = pfeil.closest('[data-mw-fd]').querySelector('[data-mw-fd-spur]');
      spur.scrollBy({ left: Number(pfeil.getAttribute('data-mw-fd-pfeil')) * spur.clientWidth, behavior: 'smooth' });
      return;
    }
    var chip = t.closest('[data-mw-fd-variante]');
    if (chip) {
      var karte = chip.closest('.mw-fd__karte');
      karte.querySelectorAll('[data-mw-fd-variante]').forEach(function (c) {
        c.setAttribute('aria-pressed', String(c === chip));
      });
      karte.querySelector('[data-mw-fd-hinzu]').setAttribute('data-mw-fd-hinzu', chip.getAttribute('data-mw-fd-variante'));
      karte.querySelector('[data-mw-fd-preis]').textContent = geld(chip.getAttribute('data-preis'));
      // Bild der Variante zeigen (Wunsch 17.10.2026)
      var bild = chip.getAttribute('data-bild');
      var img = karte.querySelector('.mw-fd__bild img');
      if (bild && img) img.src = bild;
      return;
    }
    var hinzu = t.closest('[data-mw-fd-hinzu]');
    if (hinzu) {
      event.preventDefault();
      hinzufuegen(hinzu);
    }
  });

  document.addEventListener('scroll', function (event) {
    var spur = event.target;
    if (spur && spur.matches && spur.matches('[data-mw-fd-spur]')) punkteAktualisieren(spur.closest('[data-mw-fd]'));
  }, true);

  // Kundensätze: Pfeile und × (für den Besuch ausblenden)
  try {
    if (sessionStorage.getItem('mw-zitat-zu') === '1') document.documentElement.classList.add('mw-zitat-aus');
  } catch (e) {}
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;
    var pfeil = t.closest('[data-mw-zitat-pfeil]');
    if (pfeil) {
      var spur = pfeil.closest('[data-mw-zitat]').querySelector('[data-mw-zitat-spur]');
      var r = Number(pfeil.getAttribute('data-mw-zitat-pfeil'));
      var n = spur.children.length;
      var aktiv = spur.clientWidth ? Math.round(spur.scrollLeft / spur.clientWidth) : 0;
      var ziel = (aktiv + r + n) % n;
      spur.scrollTo({ left: ziel * spur.clientWidth, behavior: 'smooth' });
      return;
    }
    if (t.closest('[data-mw-zitat-zu]')) {
      document.documentElement.classList.add('mw-zitat-aus');
      try { sessionStorage.setItem('mw-zitat-zu', '1'); } catch (e) {}
    }
  });

  // Punkte unter den Kundensätzen
  document.addEventListener('scroll', function (event) {
    var spur = event.target;
    if (!spur || !spur.matches || !spur.matches('[data-mw-zitat-spur]')) return;
    var punkte = spur.parentNode.querySelectorAll('[data-mw-zitat-punkte] i');
    var aktiv = spur.clientWidth ? Math.round(spur.scrollLeft / spur.clientWidth) : 0;
    punkte.forEach(function (p, i) { p.classList.toggle('ist', i === aktiv); });
  }, true);

  // Balken antippen: zur Geschenk-Karte scrollen, Karte leuchtet kurz auf
  // (Entscheid Albinot 17.10.2026, Tafel «Geschenk mit eigenem Platz»).
  function zumGeschenk(msg) {
    var root = msg.closest('cart-drawer-component, .cart-page');
    var karte = (root && root.querySelector('[data-mw-gs][data-gift]')) || document.querySelector('[data-mw-gs][data-gift]');
    if (!karte) return;
    if (document.documentElement.classList.contains('mw-gs-zu')) zuSetzen('gs', false);
    var scroller = karte.closest('.cart-drawer__items, .v-scrollable');
    var r = karte.getBoundingClientRect();
    if (scroller) {
      var s = scroller.getBoundingClientRect();
      scroller.scrollBy({ top: r.top - s.top - 16, behavior: 'smooth' });
    } else {
      window.scrollBy({ top: r.top - 140, behavior: 'smooth' });
    }
    karte.classList.remove('mw-gs--blitz');
    void karte.offsetWidth;
    karte.classList.add('mw-gs--blitz');
    setTimeout(function () { karte.classList.remove('mw-gs--blitz'); }, 1400);
  }
  document.addEventListener('click', function (event) {
    var msg = event.target.closest && event.target.closest('[data-mw-gs-tipp]');
    if (msg) zumGeschenk(msg);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var msg = event.target.closest && event.target.closest('[data-mw-gs-tipp]');
    if (!msg) return;
    event.preventDefault();
    zumGeschenk(msg);
  });

  document.addEventListener('mamm:fuer-dich', function (event) {
    punkteAktualisieren(event.target.closest && event.target.closest('[data-mw-fd]'));
  });

  // Pebble baut den Inhalt der Schublade bei jeder Änderung neu auf. Danach
  // die leere Empfehlungs-Stelle wieder füllen (meist aus dem Zwischenspeicher).
  var timer = null;
  function spaeter() {
    clearTimeout(timer);
    timer = setTimeout(fuellen, 60);
  }
  document.addEventListener('cart:update', spaeter);

  // Warenkorb-Seite: Total in der festen Kaufleiste am Handy = Total im Kassenbon
  function kaufleiste() {
    var ziel = document.querySelector('[data-mw-kaufleiste-total]');
    var quelle = document.querySelector('.cart-page .cart-summary__total-value');
    if (ziel && quelle && ziel.textContent !== quelle.textContent.trim()) ziel.textContent = quelle.textContent.trim();
  }

  // Feste Kaufleiste ausblenden, solange ein anderer Kassen-Knopf der Seite im Bild ist
  // (wie die Kaufleiste der Box-Seite), damit nie zwei Knöpfe zu sehen sind (Albinot 18.10.2026).
  var leisteWartet = false;
  function leisteSicht() {
    leisteWartet = false;
    var leiste = document.querySelector('[data-mw-kaufleiste]');
    if (!leiste) return;
    var oben = window.innerHeight - leiste.offsetHeight;
    var anderer = Array.prototype.some.call(
      document.querySelectorAll('.cart-page button[name="checkout"], .cart-page a[href*="/checkout"]'),
      function (k) {
        if (leiste.contains(k)) return false;
        var r = k.getBoundingClientRect();
        return r.height > 0 && r.top < oben && r.bottom > 0;
      }
    );
    leiste.classList.toggle('mw-kaufleiste--weg', anderer);
    leiste.setAttribute('aria-hidden', anderer ? 'true' : 'false');
  }
  function leisteAnstossen() {
    if (leisteWartet) return;
    leisteWartet = true;
    requestAnimationFrame(leisteSicht);
  }

  function beobachten() {
    kaufleiste();
    if (document.querySelector('[data-mw-kaufleiste]')) {
      window.addEventListener('scroll', leisteAnstossen, { passive: true });
      window.addEventListener('resize', leisteAnstossen, { passive: true });
      document.addEventListener('cart:update', leisteAnstossen);
      leisteSicht();
    }
    // Auch Änderungen in der Karte zählen: Pebbles Morph leert sie und nimmt
    // die Merker weg. Eigene Füllungen setzen data-gefuellt, also keine Schleife.
    var mo = new MutationObserver(function () {
      kaufleiste();
      leisteAnstossen();
      if (document.querySelector('[data-mw-fd-empf]:not([data-gefuellt])')) spaeter();
    });
    document.querySelectorAll('cart-drawer-component, cart-items-component').forEach(function (z) {
      mo.observe(z, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-gefuellt'] });
    });
    fuellen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachten);
  else beobachten();
})();
